const getState = () => ({
  user: {},
  session: {},
  isLogged: false,
});

export default Object.assign(getState(), { getState: getState });
